export enum TourMediaType {
  IMAGE = 'Image',
  VIDEO = 'Video',
  EMBED = 'Embed',
}
